import React, { memo } from 'react';
import type { FilterChipsProps } from '../FilterPanel.types';

const CloseIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M2 2l8 8M10 2l-8 8" strokeLinecap="round" />
  </svg>
);

function FilterChipsComponent({ chips, onRemove, onClearAll }: FilterChipsProps): React.ReactElement | null {
  if (chips.length === 0) return null;

  return (
    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: 'var(--space-2)',
      alignItems: 'center'
    }}>
      {chips.map(chip => (
        <span
          key={chip.filterId}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 'var(--space-1)',
            padding: 'var(--space-1) var(--space-2)',
            fontSize: 'var(--text-xs)',
            fontWeight: 500,
            background: 'var(--color-primary-50)',
            color: 'var(--color-primary-700)',
            borderRadius: 'var(--radius-full)',
            border: '1px solid var(--color-primary-200)'
          }}
        >
          <span style={{ color: 'var(--color-primary-500)' }}>
            {chip.label}:
          </span>
          <span>{chip.displayValue}</span>
          <button
            onClick={() => onRemove(chip.filterId)}
            aria-label={`${chip.label} filtresini kaldır`}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '16px',
              height: '16px',
              marginLeft: 'var(--space-1)',
              padding: 0,
              border: 'none',
              borderRadius: 'var(--radius-full)',
              background: 'transparent',
              color: 'var(--color-primary-500)',
              cursor: 'pointer',
              transition: 'all var(--transition-fast)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'var(--color-primary-200)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
            }}
          >
            <CloseIcon />
          </button>
        </span>
      ))}

      {chips.length > 1 && (
        <button
          onClick={onClearAll}
          style={{
            padding: 'var(--space-1) var(--space-2)',
            fontSize: 'var(--text-xs)',
            fontWeight: 500,
            color: 'var(--color-text-secondary)',
            background: 'transparent',
            border: 'none',
            borderRadius: 'var(--radius-sm)',
            cursor: 'pointer',
            transition: 'all var(--transition-fast)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = 'var(--color-negative)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = 'var(--color-text-secondary)';
          }}
        >
          Tümünü Temizle
        </button>
      )}
    </div>
  );
}

export const FilterChips = memo(FilterChipsComponent);
